import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ApprovalsPage } from '@/features/approvals/approvals-page';
import { guardRoute } from '@/lib/route-guards';

/** `?request=` opens one request (notification links, ADR-062); invalid values are dropped. */
const searchSchema = z.object({ request: z.uuid().optional().catch(undefined) });

/** `/approvals` — the unified inbox (ARCHITECTURE §7): leave, Bank & TIN, payroll runs. */
export const Route = createFileRoute('/_app/approvals')({
  validateSearch: searchSchema,
  beforeLoad: ({ context }) => {
    guardRoute(context.auth, '/approvals');
  },
  component: ApprovalsRoute,
});

function ApprovalsRoute() {
  const { request } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ApprovalsPage
      request={request ?? null}
      onRequestClosed={() => {
        if (request) void navigate({ search: {}, replace: true });
      }}
    />
  );
}
